import { useEffect, useState } from 'react';
import {
  formatMinutesDisplay,
  normalizeMinutesInput,
  parseMinutesValue,
} from '../../utils/responsibleLimits';

export default function MobileResponsibleMinutesInput({
  value,
  disabled,
  suffix,
  onChange,
}) {
  const [focused, setFocused] = useState(false);
  const [displayValue, setDisplayValue] = useState(() => formatMinutesDisplay(value));

  useEffect(() => {
    if (!focused) {
      setDisplayValue(formatMinutesDisplay(value));
    }
  }, [value, focused]);

  const filled = Boolean(displayValue);

  return (
    <div className="mobile-responsible-limit__input-wrap">
      <div className="inputContainer inputContainer_medium">
        <div
          className={[
            'inputLine',
            'inputLine_leftOffset',
            'inputLine_rightOffset',
            'inputLine_withoutBottomOffset',
            filled ? 'inputLine_filled' : '',
            focused ? 'is-focused' : '',
          ].filter(Boolean).join(' ')}
        >
          <div className="inputLine__content">
            <input
              type="text"
              className="input"
              inputMode="numeric"
              value={displayValue}
              disabled={disabled}
              onFocus={() => setFocused(true)}
              onBlur={() => {
                setFocused(false);
                const finalized = formatMinutesDisplay(parseMinutesValue(displayValue) ?? displayValue.replace(/\D/g, ''));
                setDisplayValue(finalized);
                onChange(finalized);
              }}
              onChange={(event) => {
                const next = normalizeMinutesInput(event.target.value);
                setDisplayValue(next);
                onChange(next);
              }}
              autoComplete="off"
            />
          </div>
          {suffix ? <span className="mobile-responsible-limit__suffix">{suffix}</span> : null}
        </div>
      </div>
    </div>
  );
}
